<template>
  <!--begin::Toolbar-->
  <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div
      id="kt_app_toolbar_container"
      class="app-container d-flex flex-stack w-100"
    >
      <LToolbarPageTitle />
      <!--begin::Actions-->
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <h1 class="page-heading d-flex text-dark fw-bold fs-3 justify-content-center my-0" >
          Plan seleccionado: <span class="text-primary ms-2"> {{ currentPlan ? currentPlan.name : '' }} </span>
        </h1>
      </div>
      <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
  </div>
  <!--end::Toolbar-->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { toolbarWidthFluid } from '@/assets/theme/metronic/ts/helpers/config';
import LToolbarPageTitle from '@/components/theme/metronic/layout/toolbar/PageTitle';
import {storeToRefs} from "pinia";
import {usePlansClientStore} from "~/stores/entities/client/plansClient";

export default defineComponent({
  name: 'ThemeToolbar',
  components: {
    LToolbarPageTitle
  },
  setup() {
    const plansClientStore = usePlansClientStore();

    const {currentPlan} = storeToRefs(plansClientStore);

    return {
      toolbarWidthFluid,
      currentPlan,
    };
  }
});
</script>
